const topics = [
  { id: 1, name: '顶流塌房', heat: '203.8万' },
  { id: 2, name: '反差视频合集', heat: '186.4万' },
  { id: 3, name: '圈内潜规则', heat: '172.1万' },
  { id: 4, name: '网红翻车', heat: '159.6万' },
  { id: 5, name: '明星恋情', heat: '145.2万' },
  { id: 6, name: '综艺内幕', heat: '131.7万' },
  { id: 7, name: '偶像失格', heat: '118.3万' },
  { id: 8, name: '导演丑闻', heat: '105.9万' },
  { id: 9, name: '素颜对比', heat: '92.5万' },
  { id: 10, name: '品牌解约潮', heat: '88.1万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门话题</h2>
          <p className="text-sm text-foreground-500">当前最受关注的吃瓜话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => {
            const isTop3 = topic.id <= 3;
            return (
              <div
                key={topic.id}
                className={`group flex items-center gap-2.5 px-4 py-2.5 rounded-full cursor-pointer transition-all border whitespace-nowrap ${
                  isTop3
                    ? 'bg-accent-50 border-accent-200 hover:bg-accent-100'
                    : 'bg-background-100 border-background-200 hover:border-primary-200 hover:bg-primary-50'
                }`}
              >
                <span className={`text-xs font-semibold ${isTop3 ? 'text-accent-500' : 'text-foreground-400'}`}>
                  {String(topic.id).padStart(2, '0')}
                </span>
                <span className={`text-sm font-medium ${isTop3 ? 'text-accent-800' : 'text-foreground-700'}`}>
                  {topic.name}
                </span>
                <span className={`text-xs ${isTop3 ? 'text-accent-500' : 'text-foreground-400'}`}>
                  <i className="ri-fire-line text-xs mr-0.5"></i>
                  {topic.heat}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}